import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/global/Layout"
import Seo from "../components/global/SEO"
import Nav from "../components/global/Nav"
import Footer from "../components/global/Footer"
import ParticleHeader from "../components/blocks/ParticleHeader"
import ContactGrid from "../components/blocks/ContactGrid"

const ContactPage = ({ data }) => (
  <Layout>
    {console.log(data)}
    <Seo title="Contact" />
    <Nav />
    <ParticleHeader>Contact</ParticleHeader>
    <ContactGrid
      content={
        <div
          dangerouslySetInnerHTML={{
            __html: data.prismicContact.data.content.html,
          }}
        ></div>
      }
      subtitle={data.prismicContact.data.subtitle.text}
      phone={data.prismicContact.data.phone.text}
      email={data.prismicContact.data.email.text}
    />
    <Footer />
  </Layout>
)

export const query = graphql`
  {
    prismicContact {
      data {
        content {
          html
        }
        email {
          text
        }
        phone {
          text
        }
        subtitle {
          text
        }
      }
    }
  }
`

export default ContactPage
